module.exports = __webpack_public_path__ + "static/img/3.508edc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/sp/3.png
// module id = IZT+
// module chunks = 0